var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status-badge",style:(_vm.badgeStyle),attrs:{"title":_vm.statusLabel}},[_c('i',{staticClass:"status-icon",class:_vm.statusIcon}),_c('span',{staticClass:"status-text"},[_vm._v(_vm._s(_vm.statusLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }